import dayjs from 'dayjs';

const formatDate = inputDate => {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
    }
    const dateArray = inputDate.split('-').map(Number)
    const formattedDate = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]).toLocaleDateString(undefined, options)
    return formattedDate
}
export default formatDate
export const timeDifference = (start, end, removeSec = false) => {
    const toSeconds = t => {
        const [h, m, s] = t.split(':').map(Number)
        return h * 3600 + m * 60 + s
    }

    let diff = toSeconds(end) - toSeconds(start)

    const hours = Math.floor(diff / 3600)
    diff %= 3600

    const minutes = Math.floor(diff / 60)
    const seconds = diff % 60
    if (removeSec) {
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
    }
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
export const getTimeDifference = (start, end, removeSec = false) => {
    const toSeconds = t => {
        const [h, m, s] = t.split(':').map(Number)
        return h * 3600 + m * 60 + s
    }

    let diff = toSeconds(end) - toSeconds(start)

    const hours = Math.floor(diff / 3600)
    diff %= 3600

    const minutes = Math.floor(diff / 60)
    let hoursToSet = String(hours).padStart(2, '0')
    if (hoursToSet == '00') {
        return `${String(minutes).padStart(2, '0')} Min`
    }
    return `${hoursToSet} Hr ${String(minutes).padStart(2, '0')} min`
}

export const getTimeDifferenceSeprately = (start, end) => {
    const toSeconds = t => {
        const [h, m, s] = t.split(':').map(Number)
        return h * 3600 + m * 60 + s
    }

    let diff = toSeconds(end) - toSeconds(start)

    const hours = Math.floor(diff / 3600)
    diff %= 3600

    const minutes = Math.floor(diff / 60)
    const seconds = diff % 60

    return {
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
        time: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }
}

export const getTime = () => {
    return new Date().toLocaleTimeString('en-GB', { hour12: false })
}
export const getTimeObjFromString = dateTimeStr => {
    if (!dateTimeStr) return null

    const [datePart, timePart] = dateTimeStr.split(' ')
    const [dd, mm, yyyy] = datePart.split('-')
    const [HH, MM, SS] = timePart.split(':')

    return new Date(yyyy, mm - 1, dd, HH, MM, SS)
}
export const getCurrentDate = () => {
    const date = new Date()
    const dd = String(date.getDate()).padStart(2, '0')
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const yyyy = date.getFullYear()
    return `${dd}-${mm}-${yyyy}`
}
export const getCurrentDateTime = (format = 0) => {
    const date = new Date()

    const dd = String(date.getDate()).padStart(2, '0')
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const yyyy = date.getFullYear()

    const HH = String(date.getHours()).padStart(2, '0')
    const MM = String(date.getMinutes()).padStart(2, '0')
    const SS = String(date.getSeconds()).padStart(2, '0')
    if (format == 0) {
        return `${dd}_${mm}_${yyyy}_${HH}_${MM}_${SS}`
    }
    return `${dd}-${mm}-${yyyy} ${HH}:${MM}:${SS}`
}

export const getCurrentDateInReverse = () => {
    const date = new Date()
    const dd = String(date.getDate()).padStart(2, '0')
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const yyyy = date.getFullYear()
    return `${yyyy}-${mm}-${dd}`
}


export const getFormattedDate = (newDate) => {
    const dd = String(newDate.getDate()).padStart(2, '0')
    const mm = String(newDate.getMonth() + 1).padStart(2, '0')
    const yyyy = newDate.getFullYear()
    return `${dd}-${mm}-${yyyy}`
}


export const getFormattedDateWithConvertingObj = (newDate) => {
    if (!newDate) return "";

    // Convert string to Date if needed
    const dateObj =
        newDate instanceof Date
            ? newDate
            : new Date(newDate);

    if (isNaN(dateObj)) return "";

    const dd = String(dateObj.getDate()).padStart(2, '0');
    const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
    const yyyy = dateObj.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
};

export const getFormattedDateWithConvertingObjForVanDashboard = (newDate) => {
    if (!newDate) return "";

    let dateObj;
    if (newDate instanceof Date) {
        dateObj = newDate;
    } else if (typeof newDate?.toDate === 'function') {
        dateObj = newDate.toDate();
    } else {
        dateObj = new Date(newDate);
    }

    if (isNaN(dateObj)) return "";

    const dd = String(dateObj.getDate()).padStart(2, '0');
    const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
    const yyyy = dateObj.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
};

/** Default selected value for shared DatePickerEx (AdapterDayjs). */
export const getDefaultDatePickerValue = () => dayjs();

/** Max selectable date for shared DatePickerEx — today. */
export const getMaxDateForDatePicker = () => dayjs();

/** Format DatePickerEx value to DD-MM-YYYY for API params. */
export const formatPickerDateForApi = (pickerValue) =>
    getFormattedDateWithConvertingObjForVanDashboard(pickerValue) || getCurrentDate();


export const compareTime = dateMain => {
    const [day, month, year] = dateMain.split('-')
    const date = new Date(`${year}-${month}-${day}`)

    const currentDate = new Date()

    // Set time to 00:00:00 for both dates to compare only the date part
    currentDate.setHours(0, 0, 0, 0)
    return date.getTime() < currentDate.getTime()
}


export const getDateObjFromDDMMYYYYToCompare = (dateStr) => {
    if (!dateStr) return null;

    const [dd, mm, yyyy] = dateStr.split("-").map(Number);
    return new Date(yyyy, mm - 1, dd);
};

export const getChallanFormattedDate = (dateStr) => {
    if (!dateStr || dateStr === "-") return "";

    const parts = dateStr.split(", ");
    if (parts.length < 2) return dateStr;

    return parts[1].replace(/\d{4}$/, "").trim();
};